/* =========================================================
   SPRING FLOATING EFFECT
   Furniture Roots
   ONE TIME ONLY
   ========================================================= */

document.addEventListener("DOMContentLoaded", function () {

  const container =
    document.getElementById("spring-floating-effect");

  if (!container) return;

  /* -----------------------------------------------
     Respect reduced motion
  ------------------------------------------------ */

  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  /* -----------------------------------------------
     Number of objects
  ------------------------------------------------ */

  const desktopCount = 28;
  const mobileCount = 12;

  const isMobile =
    window.innerWidth <= 749;

  const totalItems =
    isMobile
      ? mobileCount
      : desktopCount;

  /* -----------------------------------------------
     Different spring objects
  ------------------------------------------------ */

  const types = [
    "flower",
    "flower",
    "flower",
    "flower",
    "flower",
    "leaf",
    "leaf",
    "leaf",
    "petal",
    "petal",
    "petal"
  ];

  /* -----------------------------------------------
     Different flower colors
  ------------------------------------------------ */

  const flowerColors = [
    "white",
    "pink",
    "yellow",
    "peach",
    "lavender",
    "blue"
  ];

  /* -----------------------------------------------
     Different petal colors
  ------------------------------------------------ */

  const petalColors = [
    "",
    "white",
    "soft",
    "yellow",
    "peach",
    "lavender"
  ];

  /* -----------------------------------------------
     Random helper
  ------------------------------------------------ */

  function random(min, max) {

    return Math.random() * (max - min) + min;

  }

  /* -----------------------------------------------
     Random integer
  ------------------------------------------------ */

  function randomInt(min, max) {

    return Math.floor(
      Math.random() * (max - min + 1)
    ) + min;

  }

  /* -----------------------------------------------
     Create flower
  ------------------------------------------------ */

  function createFlower() {

    const flower =
      document.createElement("span");

    flower.className =
      "spring-flower";

    /* Random flower color */

    const color =
      flowerColors[
        randomInt(
          0,
          flowerColors.length - 1
        )
      ];

    flower.classList.add(color);

    /* Random flower size */

    const sizeRandom =
      Math.random();

    if (sizeRandom < 0.25) {

      flower.classList.add("small");

    } else if (sizeRandom > 0.82) {

      flower.classList.add("large");

    }

    flower.innerHTML = `
      <span class="petal"></span>
      <span class="petal"></span>
      <span class="petal"></span>
      <span class="petal"></span>
      <span class="petal"></span>
      <span class="center"></span>
    `;

    return flower;

  }

  /* -----------------------------------------------
     Create leaf
  ------------------------------------------------ */

  function createLeaf() {

    const leaf =
      document.createElement("span");

    leaf.className =
      "spring-leaf";

    const variants = [
      "",
      "light",
      "dark"
    ];

    const variant =
      variants[
        randomInt(
          0,
          variants.length - 1
        )
      ];

    if (variant) {

      leaf.classList.add(variant);

    }

    return leaf;

  }

  /* -----------------------------------------------
     Create petal
  ------------------------------------------------ */

  function createPetal() {

    const petal =
      document.createElement("span");

    petal.className =
      "spring-petal";

    const color =
      petalColors[
        randomInt(
          0,
          petalColors.length - 1
        )
      ];

    if (color) {

      petal.classList.add(color);

    }

    return petal;

  }

  /* -----------------------------------------------
     Create floating object
  ------------------------------------------------ */

  function createFloatingItem(index) {

    const item =
      document.createElement("span");

    item.className =
      "spring-float-item";

    /* Pick object */

    const type =
      types[
        randomInt(
          0,
          types.length - 1
        )
      ];

    let element;

    if (type === "flower") {

      element =
        createFlower();

    } else if (type === "leaf") {

      element =
        createLeaf();

    } else {

      element =
        createPetal();

    }

    item.appendChild(element);

    /* -------------------------------------------
       Horizontal position
    ------------------------------------------- */

    item.style.left =
      random(-3, 100) + "%";

    /* -------------------------------------------
       Animation duration
       
       All finish once.
       No infinite loop.
    ------------------------------------------- */

    const duration =
      random(8, 14);

    item.style.animationDuration =
      duration + "s";

    /* -------------------------------------------
       Stagger the flowers
       
       They won't all fall together.
    ------------------------------------------- */

    const delay =
      random(0, 4);

    item.style.animationDelay =
      delay + "s";

    /* -------------------------------------------
       Random size
    ------------------------------------------- */

    const scale =
      random(0.65, 1.15);

    element.style.transform =
      "scale(" + scale + ")";

    /* -------------------------------------------
       Add object
    ------------------------------------------- */

    container.appendChild(item);

  }

  /* -----------------------------------------------
     Generate all objects
  ------------------------------------------------ */

  for (
    let i = 0;
    i < totalItems;
    i++
  ) {

    createFloatingItem(i);

  }

  /* -----------------------------------------------
     Remove everything after animation
     
     Maximum:
     14 sec animation
     + 4 sec delay
     = 18 sec
  ------------------------------------------------ */

  setTimeout(function () {

    container.remove();

  }, 19000);

});